import { ModalService } from '@sleepstation/components'
import {
  ApiContext,
  ErrorReporterContext,
  GtmApiContext,
  LinkContext,
  RecaptchaKeyContext,
} from '@sleepstation/components-context'
import { ModalContainer } from '@sleepstation/components-hooks'
import { defaultTheme } from '@sleepstation/themes-public-site'
import { shouldForwardProp } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import { CookiesProvider } from 'react-cookie'
import { StyleSheetManager, ThemeProvider } from 'styled-components'
import startup from '../init/startup'
import { getEnvironment } from '../utils/environment'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

function Providers({ children, appElementId }) {
  const ENVIRONMENT = getEnvironment()

  const {
    restApi,
    linkContext,
    errorReporter,
    recaptchaKeyContext,
    dataLayer,
  } = startup(ENVIRONMENT)

  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <ThemeProvider theme={defaultTheme}>
        <ApiContext.Provider value={restApi}>
          <LinkContext.Provider value={linkContext}>
            <ErrorReporterContext.Provider value={errorReporter}>
              <CookiesProvider>
                <RecaptchaKeyContext.Provider value={recaptchaKeyContext}>
                  <GtmApiContext.Provider value={dataLayer}>
                    <ModalContainer.Provider>
                      <ModalService appElement={`#${appElementId}`} />
                      {children}
                    </ModalContainer.Provider>
                  </GtmApiContext.Provider>
                </RecaptchaKeyContext.Provider>
              </CookiesProvider>
            </ErrorReporterContext.Provider>
          </LinkContext.Provider>
        </ApiContext.Provider>
      </ThemeProvider>
    </StyleSheetManager>
  )
}

Providers.propTypes = {
  children: PropTypes.node.isRequired,
  appElementId: PropTypes.string.isRequired,
}

export default Providers
